import React from "react";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  TextField,
  IconButton,
  Select,
  MenuItem,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const ApiBodyTable = ({
  handleFormDataChange,
  handleFormDataDelete,
  formDatas,
}) => {
  const handleChange = (index, field, value) => {
    handleFormDataChange(index, field, value);
  };

  return (
    <Box sx={{ mt: 1, maxHeight: "200px", overflow: "auto" }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{ p: "2px 2px 2px 16px", border: "1px solid #C0C0C0" }}
            >
              <Typography fontWeight="bold">Key</Typography>
            </TableCell>
            <TableCell
              sx={{ p: "2px 2px 2px 16px", border: "1px solid #C0C0C0" }}
            >
              <Typography fontWeight="bold">Type</Typography>
            </TableCell>
            <TableCell
              sx={{ p: "2px 2px 2px 16px", border: "1px solid #C0C0C0" }}
            >
              <Typography fontWeight="bold">Value</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(formDatas.length === 0
            ? [{ key: "", value: "", type: "text" }]
            : formDatas
          ).map((formdata, idx) => (
            <TableRow
              key={idx}
              hover
              sx={{ "&:hover .delete-icon": { visibility: "visible" } }}
            >
              {/* Key */}
              <TableCell
                sx={{
                  p: "2px 2px 2px 10px",
                  border: "1px solid #C0C0C0",
                }}
              >
                <TextField
                  placeholder="Key"
                  variant="outlined"
                  value={formdata.key}
                  onChange={(e) => handleChange(idx, "key", e.target.value)}
                  fullWidth
                  sx={{
                    height: 25,
                    p: 0,
                    "& .MuiOutlinedInput-root": {
                      padding: 0,
                      fontSize: 12,
                      height: 25,
                      "& fieldset": {
                        border: "none",
                      },
                      "&:hover fieldset": {
                        border: "none",
                      },
                      "&.Mui-focused fieldset": {
                        border: "1px solid #979797",
                      },
                    },
                    "& input": {
                      height: "100%",
                      padding: "0 6px",
                      fontSize: 12,
                    },
                  }}
                />
              </TableCell>

              {/* Type */}
              <TableCell
                sx={{
                  p: "2px 2px 2px 10px",
                  border: "1px solid #C0C0C0",
                }}
              >
                <Select
                  value={formdata.type || "text"}
                  onChange={(e) => handleChange(idx, "type", e.target.value)}
                  fullWidth
                  size="small"
                  sx={{
                    fontSize: 12,
                    height: 25,
                    "& .MuiSelect-select": {
                      padding: "0 6px",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                    },
                  }}
                >
                  <MenuItem value="text">Text</MenuItem>
                  <MenuItem value="file">File</MenuItem>
                </Select>
              </TableCell>

              {/* Value */}
              <TableCell
                sx={{
                  p: "2px 2px 2px 10px",
                  position: "relative",
                  border: "1px solid #C0C0C0",
                }}
              >
                {formdata.type === "file" ? (
                  <input
                    type="file"
                    onChange={(e) =>
                      handleChange(idx, "value", e.target.files[0])
                    }
                    style={{
                      fontSize: 12,
                      padding: "2px",
                      width: "100%",
                    }}
                  />
                ) : (
                  <TextField
                    placeholder="Value"
                    variant="outlined"
                    value={formdata.value}
                    onChange={(e) =>
                      handleFormDataChange(idx, "value", e.target.value)
                    }
                    fullWidth
                    sx={{
                      height: 25,
                      "& .MuiOutlinedInput-root": {
                        padding: 0,
                        fontSize: 12,
                        height: 25,
                        "& fieldset": {
                          border: "none",
                        },
                        "&:hover fieldset": {
                          border: "none",
                        },
                        "&.Mui-focused fieldset": {
                          border: "1px solid #979797",
                        },
                      },
                      "& input": {
                        height: "100%",
                        padding: "0 6px",
                        fontSize: 12,
                      },
                    }}
                  />
                )}

                {(formdata.key || formdata.value) && (
                  <IconButton
                    onClick={() => handleFormDataDelete(idx)}
                    size="small"
                    className="delete-icon"
                    sx={{
                      visibility: "hidden",
                      position: "absolute",
                      right: 0,
                      top: 0,
                      background: "#FFFFFF",
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default ApiBodyTable;
